/* eslint-disable no-useless-return */
/* eslint-disable no-debugger */

/* eslint-disable react/self-closing-comp */
/* eslint-disable import/named */
/* eslint-disable prefer-template */
/* eslint-disable one-var */
/* eslint-disable radix */
/* eslint-disable no-else-return */
/* eslint-disable no-shadow */
/* eslint-disable react/no-unused-prop-types */
/* eslint-disable react/prop-types */
/* eslint-disable no-unused-expressions */
/* eslint-disable react/jsx-boolean-value */
/* eslint-disable vars-on-top */
/* eslint-disable eqeqeq */
/* eslint-disable array-callback-return */
/* eslint-disable consistent-return */
/* eslint-disable prefer-destructuring */
/* eslint-disable no-var */
/* eslint-disable camelcase */
/* eslint-disable arrow-body-style */
/* eslint-disable no-undef */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable object-shorthand */
/* eslint-disable no-unused-vars */
/* eslint-disable no-use-before-define */
/* eslint-disable prefer-const */
/* eslint-disable dot-notation */
/* eslint-disable no-nested-ternary */
import React, { useEffect, useState, useReducer } from "react";
import { connect, useDispatch } from "react-redux";
import PropTypes, { object } from "prop-types";
import clsx from "clsx";
import moment from "moment";
// import {  } from "@material-ui/core";
import {
  Modal,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Box,
  TextField,
  Grid,
  FormGroup,
  IconButton
} from "@material-ui/core"; // Remove the unused imports for CHG0073013
import axios from "axios";
import { useHistory } from "react-router-dom";
import DeleteIcon from "@mui/icons-material/Delete";
import { MdReplay } from "react-icons/md";
import TablePagination from "@mui/material/TablePagination";
import styles from "./TimeBookingReview.module.css";
import {
  CustomDatePicker,
  CustomFormGroup,
  CustomSelect,
  ValidatingTextField
} from "../../components/FormComponents";
import {
  DATE_FORMAT,
  API_RESOURCE_URLS,
  DISPLAY_MESSAGES,
  MESSAGE_TYPE,
  RESOURCE_TYPE,
  USER_OPERATIONS,
  Regex
} from "../../constants";
import { API } from "../../apis/api";
// import TextIcon from './TextIcon'
import { buildErrorMessage } from "../../apis/calls";
import Table from "../../components/Table/Table";
import { usePopupManager } from "../../providers/PopupManager/PopupManager";
import { AuthChecker, Button, CustomTab } from "../../atomicComponents";
import { withAllowedOperationsProvider } from "../../hocs";
import BackButton from "../../components/BackButton/BackButton";
import {
  setToast,
  setPORow,
  poSearch,
  fetchChassis,
  setChassisData,
  setAllDetails,
  getInvoice
} from "../../redux/actions/productsActions";
import { setLogin } from '../../redux/features/auth/actions'
import TableSimple from "../../atomicComponents/TableSimple1/TableSimple1";
import UserInfoPanel from "../../atomicComponents/UserInfoPanel/UserInfoPanel";
import MultiSelect from "../../components/FormComponents/MultiSelect";



const initialState = {
  plant: null,
  part: null,
  aqCommodity: null,
  purchaseCommodity: null,
  supplierCode: null,
  supplierDetails: null,
  supplierName: "",
  supplierLocation: "",
  selectedProject: null,
  selectedPO: null,
  inputFields: {
    purchaseBuyerName: "",
    suppRepresentativeName: "",
    suppRepresentativeContact: "",
    suppRepresentativeEmail: ""
  },
  errors: {}
};
const reducer = (state, action) => {
  switch (action.type) {
    case "update":
      return {
        ...state,
        [action.field]: action.value
      };
    case "reset":
      return {
        ...state,
        ...initialState
      };
    default:
      return state;
  }
};

function TimeBookingReview({
  redirectToProcessPage,
  product,
  counter,
  baseUrl,
  auth
}) {
  const ROW_HEIGHT = 38;
  const history = useHistory();

  const redirectToApplicationLandingPage = () => {
    history.push("/home");
  };

  const [state, dispatch] = useReducer(reducer, initialState);
  const { showInternalError } = usePopupManager();
  const { showPopup } = usePopupManager();
  // const dispatch1 = useDispatch();
  const dispatchNew= useDispatch();

  const {
    damage,
    invoice,
    plant,
    part,
    aqCommodity,
    purchaseCommodity,
    supplierCode,
    supplierDetails,
    supplierName,
    supplierLocation,
    selectedProject,
    selectedPO,
    inputFields,
    errors
  } = state;

  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [confirmModalFlag, setConfirmModal] = useState(false);
  const [confirmModalFlag2, setConfirmModal2] = useState(false);
  const [allTableData,setAllTableData]=useState([]);
  const [deleteParam2, handleDeleteParam2] = useState();
  const [resetAllVisitedFields, setResetAllVisitedFields] = useState(false);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);
  const [page, setPage] = React.useState(0);
  const [highlightMandatoryFields, setHighlightMandatoryFields] =
    useState(false);

  const [hover, setHover] = useState({ isHover: false, name: null });

  const [asnCount, setAsnCount] = useState(0);

  const [myState, setState] = React.useState({
    poNo: "",
    stmNo: "",
    chassisNo: null,
    toDate: null,
    fromDate: null,
    bodyBuilder: null,
    checkFlag: false
  });

  const [approveFlag, setApproveFlag] = useState(false);
  const [rejectFlag, setRejectFlag] = useState(false);
  const [aproveRejectData, setApproveRejectData] = useState("");
  const [tableData, setTableData] = useState([]);
  const [remark, setRemark] = useState("");
  const [row, setRow] = useState([]);
  const [checkedItems, setCheckedItems] = useState({});
  const [selectedProjectsDetails, setSelectedProjectsDetails] = useState([]);
  const [projectInfo, setProjectInfo] = useState([]);
  const [modifiedData, setModifiedData] = useState([]);
  const [selectDataOption, setselectDataOption] = useState([]);
  const [selectedOption, setSelectedOption] = useState([]);
  const [finalData, setFinalData] = useState([]);
  const [dataDB, setDataDB] = useState([]);
  const [commaSeparatedSelectedProject, setCommaSeparatedSelectedProject] =
    useState(null);;
 
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
  };
  const [selectAllChecked, setSelectAllChecked] = useState()
  const handleSelectAllChange = (event) => {
    const newCheckedItems = allTableData.map((_, index) => event.target.checked);
    setCheckedItems(newCheckedItems);
    setSelectAllChecked(event.target.checked);
  };
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };
  useEffect(() => {
    setSelectedProjectsDetails(allTableData.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage))
  }, [rowsPerPage, page])
  
  const handleCheckboxChange = (event, index) => {
    const { checked } = event.target;
    const selectedItem = selectedProjectsDetails[index];
  
    // Update the checkbox for the clicked row
    setCheckedItems((prevState) => ({
      ...prevState,
      [index]: checked,
    }));
  
    // If the checkbox is checked, find other checkboxes with the same date and pers_no and select them
    if (checked) {
      const selectedDate = selectedItem?.date;
      const selectedPersNo = selectedItem?.pers_no;
  
      // Find the indices of other items with the same date and pers_no
      const indicesWithSameDateAndPersNo = selectedProjectsDetails.reduce(
        (accumulator, item, i) => {
          if (item.date === selectedDate && item.pers_no === selectedPersNo) {
            accumulator.push(i);
          }
          return accumulator;
        },
        []
      );
  
      // Update the state to select checkboxes with the same date and pers_no
      setCheckedItems((prevState) => {
        const updatedState = { ...prevState };
        indicesWithSameDateAndPersNo.forEach((i) => {
          updatedState[i] = true;
        });
        return updatedState;
      });
    } else {
      // If the checkbox is unchecked, deselect other checkboxes with the same date and pers_no
      const selectedDate = selectedItem?.date;
      const selectedPersNo = selectedItem?.pers_no;
      const indicesWithSameDateAndPersNo = selectedProjectsDetails.reduce(
        (accumulator, item, i) => {
          if (item.date === selectedDate && item.pers_no === selectedPersNo) {
            accumulator.push(i);
          }
          return accumulator;
        },
        []
      );
  
      // Update the state to deselect checkboxes with the same date and pers_no
      setCheckedItems((prevState) => {
        const updatedState = { ...prevState };
        indicesWithSameDateAndPersNo.forEach((i) => {
          updatedState[i] = false;
        });
        return updatedState;
      });
    }
  };
  

  const updateFinalData = () => {
    const filteredData = modifiedData.filter(
      (item, index) => checkedItems[index] === true
    );
    // console.log(filteredData,"filteredData 524 priya search")
    setFinalData(filteredData);
  };

  useEffect(() => {
    if (checkedItems?.length != 0) {
      updateFinalData();
    }
  }, [checkedItems, modifiedData]);

  useEffect(() => {
    // console.log(commaSeparatedSelectedProject,"commaSeparatedSelectedProject")
    if (commaSeparatedSelectedProject?.length > 0) {
      const filteredProjects = projectInfo.filter((project) =>
        commaSeparatedSelectedProject.includes(project.pers_no)
      );
      setSelectedProjectsDetails(filteredProjects);
    } else{
      // console.log("hitest")
      getEmployeeDetails();
    }
  }, [commaSeparatedSelectedProject]);

  const handleChangeSelect = (selectedOption) => {
    setSelectedOption(selectedOption);
    setCommaSeparatedSelectedProject(
      selectedOption?.map((data) => data.value).join(",")
    );
  };

  const [backgroundColors, setBackgroundColors] = useState({
    processInfoBg: true,
    supplierInfoBg: false,
    poInfoBg: false,
    projectsInfoBg: false
  });

  const changeBackgroundColor = (field) =>
    setBackgroundColors((prev) => {
      const newBackgroundColors = {};
      // eslint-disable-next-line no-restricted-syntax
      for (const [key, value] of Object.entries(prev)) {
        if (key === field) newBackgroundColors[key] = true;
        else newBackgroundColors[key] = false;
      }
      return newBackgroundColors;
    });

  const handleClose = () => setIsPopupOpen(false);
  const handleOpen1 = () => {
    setConfirmModal(true);
  };
  const handleOpen2 = () => {
    setConfirmModal2(true);
  };
  const handleClose2 = () => setConfirmModal2(false);
  const resetFields = () => {
    if (myState.checkFlag == true) {
      setState((prevData) => ({
        ...prevData,
        chassisNo: null,
        toDate: null,
        fromDate: null
      }));
    } else {
      setState((prevData) => ({
        ...prevData,
        chassisNo: null,
        toDate: null,
        fromDate: null,
        bodyBuilder: null
      }));
    }

    // setTableData([]);
    setHighlightMandatoryFields(false);
  };

  const renderOther = () => (
    <>
      {selectedProjectsDetails?.length > 0 && (
        <div
          className={styles.formGroup}
          // style={{ backgroundColor: processInfoBg ? BG_COLOR : null }}
          onClick={() => changeBackgroundColor("processInfoBg")}
        >
          <Grid
            container
            spacing={1}
            style={{ marginTop: "10px" }}
            // className={styles.myGrid}
            columns={12}
          >
            <Grid item md={2} lg={2} sm={4} xs={4}>
              <div className={styles.rowDiv}>
                {/* <div className={clsx(styles.lableDiv)}> */}
                <label>Employee Details:</label>
                {/* </div> */}
              </div>
            </Grid>
            <Grid item md={3} lg={3} sm={8} xs={8}>
              <div className={styles.rowDiv}>
                <MultiSelect
                  isMandatory
                  className={clsx(styles.select, styles.sel2)}
                  isMulti={true}
                  isClearable
                  options={selectDataOption}
                  name="ticketno"
                  onChange={handleChangeSelect}
                  
                />
              </div>
            </Grid>
          </Grid>
        </div>
      )}
    </>
  );

  const getEmployeeDetails = () => {
    let apiFormatedData = {
      co_code: auth.companyCode,
      pers_no: auth.personNumber
    };
    var apiFormatedDataJson = JSON.stringify(apiFormatedData);
    let headerss = new Headers();
    headerss.append("Content-Type", "application/json");
    fetch(`${baseUrl}timeBooking/TimeBookingReview`, {
      method: "POST",
      headers: headerss,
      credentials:"include",
      body: apiFormatedDataJson
    })
      .then((response) => {
        dispatchNew(setLogin({...auth, recentStatus: response.status}))
        return response.json();
        })
      .then((responseJson) => {
        if(responseJson.data.length==0){
         showPopup({
          type: MESSAGE_TYPE.INFORMATION,
          contextText: MESSAGE_TYPE.INFORMATION,
          info: "No Pending Booking Approvals",
        });
        history.push("/home")   
        }
        else{
          
          setSelectedProjectsDetails(responseJson.data);
          setAllTableData(responseJson.data)
          setProjectInfo(responseJson.data);
          // console.log(responseJson,"responseJsondata")
          const selectOption = responseJson.data.map(({ pers_no,complete_name }) => ({
            value: pers_no,
            label: `${pers_no}-${complete_name}`
          }));
          let jsonObject = selectOption.map(JSON.stringify);
          let uniqueSet = new Set(jsonObject);
          let uniqueArray = Array.from(uniqueSet).map(JSON.parse);
          setselectDataOption(uniqueArray);
        }    
      })
      .catch((error) => {
  
      });
  };

  const handleSelectedProjectsChange = (newSelectedProjects) => {
    // console.log(newSelectedProjects,"newSelectedProjects 609 priya")

    const newModifiedData = newSelectedProjects.map((item) => ({
      ...item,
      remark: item.remark || ""
    }));
    setModifiedData(newModifiedData);
  };

  // console.log(modifiedData,"newModifiedData 477")

  useEffect(() => {
    if (selectedProjectsDetails?.length > 0) {
      handleSelectedProjectsChange(selectedProjectsDetails);
    }
  }, [selectedProjectsDetails]);

  const handleCancel = () => {
    window.location.reload();
  };


  const handleSave = (data) => {
    if (finalData?.length === 0) {
      showPopup({
        type: MESSAGE_TYPE.INFORMATION,
        contextText: MESSAGE_TYPE.INFORMATION,
        info: "Please select at least one project."
      });
      return; // Stop further processing
    }
    else {
      const date = new Date();
      let day = date.getDate();
      let month = date.getMonth() + 1;
      let year = date.getFullYear();
      let currentDate = `${year}-${month}-${day}`;
      const resultList = finalData.map((projectData) => (
        {
          str_pers_no: projectData.pers_no.toString(),
          appr_by: auth.personNumber,
          book_date: projectData.date,
          book_type: projectData.status,
          flag: data,
          activity_desc: projectData.activity_desc,
          mfl: projectData.mfl,
          no_of_hours: projectData.no_of_hours,
          project_def: projectData.project_def,
          project_desc: projectData.project_desc,
          remark1: projectData.remark,
          appr_date: currentDate
        }
      ));
      axios
        .post(`${baseUrl}timeBooking/ApproveRejectTimeBooking`, resultList,{
          headers: {
          'Content-Type': 'application/json',         
          },
          withCredentials:true
        },)
        .then((res) => {
         dispatchNew(setLogin({...auth, recentStatus: res.status}))
          if (res.data.msg === "Request Approved Successfully.") {          
            showPopup({
              type: MESSAGE_TYPE.SUCCESS,
              contextText: MESSAGE_TYPE.SUCCESS,
              info: res.data.msg,
              reloads: true, // Set reload to true or false based on your condition
            });
          }
          else if(res.data.msg === "Request Rejected Successfully."){
            showPopup({
              type: MESSAGE_TYPE.SUCCESS,
              contextText: MESSAGE_TYPE.SUCCESS,
              info: res.data.msg,
              reloads: true, // Set reload to true or false based on your condition
            });
          }
           else {
            showPopup({
              type: MESSAGE_TYPE.FAILURE,
              contextText: MESSAGE_TYPE.FAILURE,
              info: "failed.",
            });
          }
        })
        .catch((error) => {
          dispatchNew(setLogin({...auth, recentStatus: error.response.status }));
          // console.error("Error while saving:", error);
        });
    }

  
  };

  const handleHrsChange = (event, index) => {
    const { value } = event.target;
    const updatedModifiedData = [...modifiedData];
    if (index >= 0 && index < updatedModifiedData?.length) {
      updatedModifiedData[index].remark = value;
      setModifiedData(updatedModifiedData);
    }
  };

  const renderReport = () => (
    <div className={styles.formGroup}>
      <Grid
        container
        spacing={1}
        style={{ marginTop: "5px" }}
        // className={styles.myGrid}
        columns={12}
      >
        <Grid item md={12} lg={12} xs={12} sm={12}>
          <Grid item md={12} lg={12} xs={12} className={clsx(styles.scrollBar)}>
            <TableSimple
              tableColumnData={[

                ...selectedProjectsDetails.map((info, index) => ({
                select: (
                  <input
                    type="checkbox"
                    // disabled={rejectFlag}
                    checked={checkedItems[index] || false}
                    onChange={(event) => handleCheckboxChange(event, index)}
                  />
                ),
                
                ticket: info.pers_no,
                EmployeeName: info.complete_name,
                Date: moment(info.date).format("DD-MM-YYYY"),
                Status: info.status,
                projectno:
                  info.project_def == null
                    ? info.activity_desc
                    : info.project_def,
                projectdesc: info.project_desc,
                gateevm: info.activity_desc,
                modulemfl: info.mfl,
                hours: info.no_of_hours,
                remark: (
                  <ValidatingTextField
                    variant="outlined"
                    size="small"
                    onChange={(e) => handleHrsChange(e, index)}
                    name="hour"
                    isDisabled={!checkedItems[index]}
                    inputProps={{
                      "data-testid": "remark-input"
                    }}
                    style={{ width: "100%" }}
                  />
                )
              }))]}
              tableHeaderLabel={[
                            
                "Select",
                "Ticket No._30",
                "Employee Name_50",
                "Date_60",
                "Status_50",
                "Project/Indirect No._62",
                "Project/Indirect Desc_70",
                "Gate (EVM Activity)_50",
                "Module(MFL)_55",
                "Hours_30",
                "Remark_50"
              ]}
              TableRowHederAling="center"
              size="small"
              headerColor="#E6F2FF"
              className="custom-table"
              selectAllChecked={selectAllChecked}
              handleSelectAllChange={handleSelectAllChange}
              checkedItems={checkedItems}
              handleCheckboxChange={handleCheckboxChange}


            />
            <TablePagination
            rowsPerPageOptions={[10, 25, 100]}
            component="div"
            count={allTableData?.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
            checkedItems={checkedItems}

          />
          </Grid>
        </Grid>
      </Grid>
      <Grid
        container
        spacing={1}
        style={{ marginTop: "10px", justifyContent: "center" }}
        className={styles.myGrid}
        columns={12}
      >
        <Grid item md={5} lg={5}>
          <div className={styles.rowDiv}>
            <div className={styles.formDiv}>
              <Button
                className={clsx(styles.primaryActionButton)}
                variant="primary"
                data-testid="confirm-action"
                style={{ marginRight: "35px" }}
                onClick={() => {
                  handleSave("APPR");
                  setRejectFlag(true);
                }}
                // onClick={()=>handleApprove("APPR")}
                // disabled={rejectFlag}
              >
                APPROVE
              </Button>
              <Button
                className={clsx(styles.primaryActionButton)}
                variant="primary"
                data-testid="confirm-action"
                style={{ marginRight: "35px" }}
                // onClick={()=>handleApprove()}
                // onClick={()=>handleReject("REJECT")}
                onClick={() => {
                  handleSave("REJECT");
                  setApproveFlag(true);
                }}
                // disabled={!rejectFlag}
              >
                REJECT
              </Button>

              <Button
                className={clsx(styles.actionButton, styles.resetButton)}
                variant="tertiary"
                style={{ marginRight: "5px" }}
                onClick={handleCancel}
              >
                Cancel
              </Button>
            </div>
          </div>
        </Grid>
      </Grid>
    </div>
  );

  const resetAllInputs = () => {
    const inputs = {
      purchaseBuyerName: "",
      suppRepresentativeName: "",
      suppRepresentativeContact: "",
      suppRepresentativeEmail: ""
    };
    dispatch({ type: "update", field: "inputFields", value: inputs });
    dispatch({ type: "update", field: "errors", value: {} });
  };

  const resetState = () => {
    dispatch({ type: "reset" });
    resetAllInputs();
    setHighlightMandatoryFields(null);
    setResetAllVisitedFields(false);
    changeBackgroundColor("processInfoBg");
  };

  useEffect(() => {
    if (resetAllVisitedFields) resetState();
  }, [resetAllVisitedFields]);



  return (
    <>
      {auth.userRole.includes("M") ? (
        <>
          {" "}
          <div className={styles.container} style={{ boxSizing: "border-box" }}>
            <div
              className={styles.backButtonLastRefreshedDateWrapper}
              style={{ display: "none" }}
            >
              <BackButton
                action="Home"
                handleClick={redirectToApplicationLandingPage}
              />
            </div>
            <div className={styles.processHeader}>
              <div className={styles.CustomTabClass}>
                <CustomTab title="Time Booking" withOutCount isSelected />
              </div>
              <div className={styles.processTopbar}>
                <UserInfoPanel />
              </div>
            </div>
            {/* <WarningModal
              open={isWarningOpen}
              // rowsData={selectedRows}
              confirmDelete={() => handleOk()}
              msg={warningMessage}
              popUpHeading="Alert"
            /> */}
            {/* /<Test/> */}

            <div
              className={clsx(
                styles.scrollContainer,
                styles.formContainer
              )}
            >
              <CustomFormGroup
                header="Time Booking Review: While approving Managers need to ensure correctness of Project (WBS) , Gate (EVM Activity), Module (MFL Activity )"
                body={renderOther()}
              />
              {selectedProjectsDetails?.length > 0 && renderReport()}
            </div>
          </div>
          <ResetModal
            isPopupOpen={isPopupOpen}
            handleClose={handleClose}
            resetFields={resetFields}
          />
          <ResetModal2
            a={confirmModalFlag2}
            handleCase={handleClose2}
            onDelete={() => onDeleteRow2(deleteParam2)}
          />
        </>
      ) : (
        ""
      )}
    </>
  );
}

function ResetModal2({ a, handleCase, onDelete }) {
  return (
    <Dialog
      open={a}
      className={styles.popContainer}
      classes={{
        paper: styles.popupBox
      }}
      data-testid="reset-popup1"
    >
      <>
        <DialogTitle>
          <span className={styles.title}>
            <DeleteIcon style={{ height: "18px", width: "18px" }} />
            <span className={styles.txt}>Are you sure ?</span>
          </span>
        </DialogTitle>
        <DialogContent className={styles.content}>
          <span>Do you want to delete ?</span>
        </DialogContent>
        <DialogActions>
          <Button
            className={clsx(styles.actionButton, styles.transparentButton)}
            onClick={handleCase}
          >
            Cancel
          </Button>
          <Button
            className={clsx(styles.actionButton, styles.primaryActionButton)}
            variant="primary"
            onClick={onDelete}
          >
            Yes
          </Button>
        </DialogActions>
      </>
    </Dialog>
  );
}
function ResetModal1({ a, handleCase, onDelete }) {
  return (
    <Dialog
      open={a}
      className={styles.popContainer}
      classes={{
        paper: styles.popupBox
      }}
      data-testid="reset-popup1"
    >
      <>
        <DialogTitle>
          <span className={styles.title}>
            <DeleteIcon style={{ height: "18px", width: "18px" }} />
            <span className={styles.txt}>Are you sure ?</span>
          </span>
        </DialogTitle>
        <DialogContent className={styles.content}>
          <span>Do you want to delete ?</span>
        </DialogContent>
        <DialogActions>
          <Button
            className={clsx(styles.actionButton, styles.transparentButton)}
            onClick={handleCase}
          >
            Cancel
          </Button>
          <Button
            className={clsx(styles.actionButton, styles.primaryActionButton)}
            variant="primary"
            onClick={onDelete}
          >
            Yes
          </Button>
        </DialogActions>
      </>
    </Dialog>
  );
}

function ResetModal({ isPopupOpen, handleClose, resetFields }) {
  return (
    <Dialog
      open={isPopupOpen}
      className={styles.popContainer}
      classes={{
        paper: styles.popupBox
      }}
      data-testid="reset-popup"
    >
      <>
        <DialogTitle>
          <span className={styles.title}>
            <MdReplay style={{ height: "18px", width: "18px" }} />
            <span className={styles.txt}>Reset</span>
          </span>
        </DialogTitle>
        <DialogContent className={styles.content}>
          <span>Are you sure you want to reset the filters?</span>
        </DialogContent>
        <DialogActions>
          <Button
            className={clsx(styles.actionButton, styles.transparentButton)}
            onClick={handleClose}
          >
            Cancel
          </Button>
          <Button
            className={clsx(styles.actionButton, styles.primaryActionButton)}
            variant="primary"
            onClick={(e) => {
              e.preventDefault();
              handleClose();
              resetFields();
            }}
          >
            Yes
          </Button>
        </DialogActions>
      </>
    </Dialog>
  );
}

TimeBookingReview.propTypes = {
  redirectToProcessPage: PropTypes.func
};

ResetModal.propTypes = {
  isPopupOpen: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
  resetFields: PropTypes.func.isRequired
};
ResetModal1.propTypes = {
  a: PropTypes.bool.isRequired,
  handleCase: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired
};
ResetModal2.propTypes = {
  a: PropTypes.bool.isRequired,
  handleCase: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired
};

const mapStateToProps = (state) => ({
  product: state.product,
  counter: state.counter.value,
  baseUrl: state.counter.baseUrl,
  auth: state.auth
});
const mapDispatchToProps = (dispatch) => ({
  fetchChassis: (chassisParam) => dispatch(fetchChassis(chassisParam)),
  getInvoice: (chassisParam) => dispatch(getInvoice(chassisParam))
});
TimeBookingReview.propTypes = {
  counter: PropTypes.number,
  baseUrl: PropTypes.string,
  product: PropTypes.object,
  auth: PropTypes.object
};
const App = connect(mapStateToProps, mapDispatchToProps)(TimeBookingReview);

export default withAllowedOperationsProvider(App, RESOURCE_TYPE.PPAP);